module.exports = __webpack_public_path__ + "img/3x.30eac1e.jpg";